export const PRO_STORAGE_GB = 50;

// 320kbps stereo MP3 ≈ 140 MB/hour → GB * 1024 / 140
export const PRO_STORAGE_HOURS_320KBPS = Math.round((PRO_STORAGE_GB * 1024) / 140);
